import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=ed44205e&"
import script from "./Clientes.vue?vue&type=script&lang=js&"
export * from "./Clientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports